module.exports = "body.login {\r\n    overflow: hidden;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main